import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const designViewerSlice = createSlice({
  name: "isFileAnOlderVersion",
  initialState: false,
  reducers: {
    setIsFileAnOlderVersion: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setIsFileAnOlderVersion } = designViewerSlice.actions;

export const isFileAnOlderVersion = designViewerSlice.reducer;

export default designViewerSlice.reducer;
